// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"nEUhx","modalControls":"_3r45A","deleteBtnWrapper":"_2_xvH"};